import template from './truck.edit.html';
import controller from './truck.edit.controller';
import './truck.edit.scss';

let truckeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default truckeditComponent;


// WEBPACK FOOTER //
// ./client/app/components/truck/edit/truck.edit.component.js